import { render } from "./PlotView.vue?vue&type=template&id=839d134e"
import script from "./PlotView.vue?vue&type=script&lang=js"
export * from "./PlotView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__